import { persistStateTypes as PERSIST_STATE_TYPES } from 'a/reducers/persistStateReducer';
import { ACTIONS } from 'a/placementTool/data/constants';
import { validateWordReadingData } from 'a/placementTool/lib/utilityFunctions';
import gameIds from 'root/activities/hub/data/GameIds';
import { MEASURE_ID } from '../../constants';

const GAME_ID = gameIds.LETTER_SOUND_CORRESPONDENCES;

/**
 * Most RWR state is handled internally for RWR, so this reducer is literally
 * just for intermediate saves and reporting final scores.
 */

export const initialState = {
  questionIndex: 0,
  responses: {},
  numberIncorrect: 0,
  questionsCorrectByItemType: {},
  hasLoaded: false,
  areCompleteEventsFired: false,
  roundSessionData: {},
};

export default (state = initialState, { gameId, type, stateData }) => {
  if (gameId !== MEASURE_ID && gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case PERSIST_STATE_TYPES.POST_GAMESTATE:
      try {
        validateWordReadingData(stateData);
        return mergeStateUpdates(state, stateData);
      } catch (e) {
        console.error(
          'Real Word Reading: There was a problem with the saved data sent to server.\n'
          + `${e.message}\n\nBad Object:\n`, stateData,
        );
      }
      return state;
    case ACTIONS.COMPLETE_EVENTS_FIRED:
      return {
        ...state,
        areCompleteEventsFired: true,
      };
    case PERSIST_STATE_TYPES.REQUESTERROR_GAMESTATE:
    default:
      return state;
  }
};

// persistState save automatically adds the roundSessionData in a gameDetails object and our state obj
// does not want it nested nor does it want the gameDetails key at all. So we destructure it out and
// flatten the pieces into the currentState for our new state obj
const mergeStateUpdates = (
  currentState,
  {
    gameDetails: {
      roundSessionData = {},
    } = {},
    roundSessionId,
    ...stateUpdates
  },
) => ({
  ...currentState,
  ...stateUpdates,
  roundSessionData: {
    ...roundSessionData,
    roundSessionId,
  },
});
